<template lang="pug">
  v-layout.box-beneficiarios-desktop-formatter(column align-center)
    //-POPUP-ALERT
    PopupAlertMessage(
      @closeAlertPopup="actionPopupMethod($event, popupAlert.option)"
      :openPopup="popupAlert.openPopup"
      :image="popupAlert.image"
      :title="popupAlert.title"
      :message="popupAlert.message"
      :messageButton="popupAlert.messageButton"
      :buttonClose="popupAlert.buttonClose"
      :imgHeight="popupAlert.imgHeight"
      :imgWidth="popupAlert.imgWidth"
        )
    v-flex(style="width: 85%;")
      p.omnesMedium.g-text-center.no-beneficiaries-title(v-if="beneficiariosPrincipales.length === 0") Aquí podrás visualizar tus beneficiarios
      span(v-if="beneficiariosPrincipales.length > 0" style="line-height: 0;color: #454A6C;") Estos son tus beneficiaros actualmente
    v-flex(v-if="beneficiariosPrincipales.length === 0")
      v-img
        img(style="display:flex; margin:auto;" :src="iconNoBeneficiaries")
      p(v-if="!poliza.oriProducto.includes('VIDA_CASH_PLUS')").omnesMedium.g-text-center.no-beneficiaries-description En el caso de no contar con estos,
        br
        | puedes agregar tus beneficiarios desde aquí.
      p(v-if="poliza.oriProducto.includes('VIDA_CASH_PLUS')").omnesMedium.g-text-center.no-beneficiaries-description
        | Puedes agregar beneficiarios contactándonos con nuestro canales de comunicación, si aún no los has registrado.
    v-flex(v-if="beneficiariosPrincipales.length > 0" style="margin: 0.8em 0em;max-width: 100% !important;width: 85%;")
      v-layout(column fill-heigh)
        v-flex(style="margin-bottom:1em;")
          v-layout(column)
            v-flex.box-benefiarios
              span(style="font-size: 14px;color: #454A6C;") Beneficiarios principales
              v-tooltip(bottom max-width="220")
                template(v-slot:activator="{on}")
                  img(style="height: 16px;align-self: center;" :src="iconInterrogacion" v-on="on")
                span(style="color: #ffffff") Los beneficiarios principales son las personas designadas para recibir el beneficio del seguro, en caso de fallecimiento del asegurado durante la vigencia de la póliza.
            v-flex.box-datos-beneficiarios(
              :style="{'max-height': beneficiariosPrincipales.length<=3 && beneficiariosContingentes.length==0  ? '15.9em !important' : ''  }"
              )
              v-layout(column)
                v-flex(style="width: fit-content;margin: 0.5em 0em;" v-for="(item, index) in beneficiariosPrincipales" :key="index")
                  TarjetaBeneficiarioIconDetalle(
                    :numeroBeneficiario = "index + 1"
                    :nombreBeneficiario = "item.nombre+' '+item.apellidoPaterno"
                    :porcentajeBeneficio = "item.porcentajeDistribucion"
                    )
        v-flex(v-if="beneficiariosContingentes.length >0" style="padding-top:0.5em;border-top: 1px solid #C9C9C9;")
          v-layout(column)
            v-flex.box-benefiarios
              span(style="font-size: 14px;color: #454A6C;") Beneficiarios contingentes
              v-tooltip(bottom max-width="220")
                template(v-slot:activator="{on}")
                  img(style="height: 16px;align-self: center;" :src="iconInterrogacion" v-on="on")
                span(style="color: #ffffff") El beneficiario contingente  es la persona o personas designadas para recibir el beneficio del seguro, en caso que el asegurado y él o los beneficiarios principales fallezcan durante la vigencia de la póliza.
            v-flex()
              v-layout(column)
                v-flex(style="width: fit-content;margin: 0.5em 0em;" v-for="(item, index) in beneficiariosContingentes" :key="index")
                  TarjetaBeneficiarioIconDetalle(
                    :numeroBeneficiario="index + 1"
                    :nombreBeneficiario = "item.nombre+' '+item.apellidoPaterno"
                    :porcentajeBeneficio = "item.porcentajeDistribucion"
                    :activo = "flag"
                    )
    v-flex(
      v-if="puedeCambiarBeneficiario"
      :style="{'margin-top': (beneficiariosPrincipales.length<2 && beneficiariosContingentes.length<2) ? '1em !important' : ''  ,}"
    )
      v-btn.beneficiaries-button(@click="modificarBeneficiariosMethod" color="#EA0D90")
        span Modificar Beneficiario
    v-flex.box-button-beneficiario(v-if="!poliza.oriProducto.includes('VIDA_CASH_PLUS')" mt-4)
      v-layout(row)
        v-flex(xs1 mr-2)
          img(:src="iconAlerta")
        v-flex(v-if="puedeCambiarBeneficiario")
          span(style="color: #919191;font-size:13px;") Recuerda que los cambios se verán reflejados cuando la solicitud sea aprobada.
        v-flex(v-if="!puedeCambiarBeneficiario")
          span(style="color: #919191;font-size:13px;") Si deseas modificar a tus beneficiarios, por favor comunícate &nbsp;
          a.omnesMedium(:href="links.WhatsApp" target="_blank" style="cursor:pointer;color:#919191") aquí
          | .
</template>

<script>
import * as d3 from 'd3'
import PopupAlertMessage from '../PopupAlertMessage.vue'
import IconText from './../generic/IconText.vue'
import {mapActions, mapGetters} from 'vuex'
import TarjetaBeneficiarioIconDetalle from './../generic/TarjetaBeneficiarioIconDetalle.vue'
import Links from '../../interfaces/links'
import Functionalities from '../../interfaces/functionalities'

export default {
  props: [
    'beneficiariosPrincipales',
    'beneficiariosContingentes',
    'puedeCambiarBeneficiario',
    'poliza',
    'taggeo'
  ],
  data () {
    return {
      links: Links,
      iconHombre: require('./../../assets/icons-mis-seguros/icon-beneficiario.svg'),
      iconMujer: require('./../../assets/icons-mis-seguros/icon-beneficiaria.svg'),
      iconInterrogacion: require('./../../assets/iconsv5/icon-question.svg'),
      iconAlerta: require('./../../assets/iconsv5/icon-alert.svg'),
      iconNoBeneficiaries: require('@/assets/icons-mis-seguros/icono-mi-agente2.svg'),
      principal: this.beneficiariosPrincipales,
      contingente: this.beneficiariosContingentes,
      flag: true,
      popupAlert: {
        openPopup: false,
        option: '',
        image: require('@/assets/characters/informa.svg'),
        title: 'Estimado cliente',
        message: '',
        messageButton: 'Entendido',
        buttonClose: false,
        imgHeight: 150,
        imgWidth: 150
      }
    }
  },
  methods: {
    ...mapActions('event', ['eventLog']),
    methodClosePopup () {
      this.$emit('closePopup')
    },
    modificarBeneficiariosMethod () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.vida.VIMDB, self.functionsRules, self)) {
        return
      }
      this.popupAlert.openPopup = true
      this.popupAlert.option = 'beneficiarios'
      this.popupAlert.title = 'Estimado cliente'
      this.popupAlert.message = this.puedeCambiarBeneficiario ? 'Te redireccionaremos a la solicitud modificación de beneficiarios...' : 'En estos momentos no puede realizar esta solicitud'
      this.popupAlert.messageButton = 'Entendido'
      this.popupAlert.buttonClose = this.puedeCambiarBeneficiario
    },
    actionPopupMethod (action, option) {
      if (option === 'beneficiarios' && action && this.puedeCambiarBeneficiario) {
        this.$router.push({ name: 'PerfilBeneficiarios',
          params: {
            policy: this.poliza.numeroPoliza,
            productName: this.poliza.producto,
            producto: this.poliza.ramo,
            subProducto: this.poliza.nombreProducto
          }
        })
          .then(data => {
            this.loader.flag = false
            this.popupAlert.openPopup = false
          }).catch(() => {
            this.popupAlert.openPopup = true
            this.popupAlert.title = 'Estimado cliente'
            this.popupAlert.message = 'No hemos logrado ir a Modificación de Beneficiarios. Por favor, volver a intentarlo en unos minutos o comunicarse con nuestro Servicio de Atención al Cliente.'
            this.popupAlert.messageButton = 'Entendido'
            this.popupAlert.buttonClose = false

            this.loader.flag = false
          })
      }
      this.popupAlert.openPopup = false
    }
  },
  components: {
    TarjetaBeneficiarioIconDetalle,
    IconText,
    PopupAlertMessage
  },
  computed: {
    ...mapGetters('user', ['functionsRules'])
  },
  mounted () {
    let self = this

    const metadata = {
      numeroPoliza: self.taggeo.numeroPoliza,
      antiguedad: self.taggeo.antiguedad,
      productoConsultado: self.taggeo.ramo,
      subproductoConsultado: self.taggeo.nombreProducto
    }
    self.$root.$emit('npsInactivity', {seccion: 'Mis seguros - Plan - Mis beneficiarios', metadata})

    d3.select('.box-beneficiarios-desktop-formatter')
      .style('opacity', '0')
      .transition().duration(300)
      .style('opacity', '1')

    self.eventLog({
      'tipoDocumento': self.taggeo.tipoDocumento,
      'numeroDocumento': self.taggeo.numeroDocumento,
      'categoria': 'Consulta',
      'nombre': self.taggeo.nombre,
      'datos': {
        'numeroPoliza': self.taggeo.numeroPoliza,
        'antiguedad': self.taggeo.antiguedad,
        'grupoProducto': self.taggeo.ramo,
        'producto': self.taggeo.nombreProducto,
        'navegacion': 'Plan',
        'dispositivo': 'desktop',
        'seccion': 'mis beneficiarios'
      }
    })
  }
}
</script>

<style scoped>
.box-beneficiarios-desktop-formatter {
  margin: 1em auto;
}

.box-beneficiarios-desktop-formatter .box-datos-beneficiarios {
  overflow-y: auto;
}

.box-beneficiarios-desktop-formatter .box-benefiarios {
  display: flex;
  margin: 0.5em 0em;
}

.box-beneficiarios-desktop-formatter .box-benefiarios img {
  margin: 0em 1em
}

.box-beneficiarios-desktop-formatter .box-button-beneficiario {
  text-align: justify;
  width: 20em;
  line-height: normal;
  margin-top: 1em
}

.no-beneficiaries-title {
  color: var(--first-brand-color);
  font-size: 16px;
}

.no-beneficiaries-description {
  color: var(--text-color);
  font-size: 14px;
  line-height: 1.3;
  margin: 15px 0 10px;
}

.beneficiaries-button {
  height: 3em;
  width: 16em;
}

.beneficiaries-button span {
  text-transform: initial;
  font-size: 16px;
  color: var(--white-color);
}
</style>



// WEBPACK FOOTER //
// src/components/mis-seguros/MisBeneficiariosDesktop.vue